<xpo-shell [routes]="(routes$ | async)!">
  <xpo-header-app-name>Edge</xpo-header-app-name>
  <xpo-header-sub-app-name>Sales Ops</xpo-header-sub-app-name>
  <router-outlet></router-outlet>
</xpo-shell>
